import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { Button, Col, Container, Row } from "react-bootstrap";
import Loader from "../SharedComponent/Loader/Loader";
import { fetchAdsListByPosting, fetchParamsListData} from "../ReduxState/Actions/actionAd";
import { fetchDataRequest, getSummayDetails} from "../ReduxState/Actions/actionAd";
import { currentDateAsTmrw } from "../Utils/Utils";
import DatePicker from "react-datepicker";
import "./FilterFetchForm.scss";

const getPageConfigStorageKey = (regionId, date) => {
  const formattedDate =
    date instanceof Date ? date.toISOString().split("T")[0] : date;

  return `scheduler_page_config_${regionId}_${formattedDate}`;
};

export default function FilterFetchForm({ regionVal ,setSelectedJacketType,setSelectedFrontPage,selectedJacketType,
  selectedFrontPage,setUserSelectedJacket,setUserSelectedFrontPage,}) {
  const dispatch = useDispatch();
  const { fetchMetaDataInitalDataParams } = useSelector(
    (state) => state.fetchinitialmetadata
  );
  const { fetcheadsbypositingLoading } = useSelector(
    (state) => state.fetcheadsbypositing
  );


  const { data} = useSelector((state) => state.data);
  // console.log('data :', data)
  
  const [dateValue, setDateValue] = useState(currentDateAsTmrw);
  const [formSubmittingData, setFormSubmittingData] = useState({
    adType: null,
    pageNumber: null,
    position: null,
    editionType: null,
    paperNumber: null,
    jacketType: null,
    FrontPage: null,
    dateValue: dateValue?.toISOString().split("T")[0],
  });
  const [dropDownValue, setDropDownValue] = useState({
    adType: [],
    pageNumber: [],
    position: [],
    editionType: [
      { label: "Single", value: "single" },
      { label: "Twin", value: "twin" },
    ],
    paperNumber: [
      { label: "One", value: "one" },
      { label: "Two", value: "two" },
    ],
    jacketType: [
      {label: "No Jacket", value: null},
      {label: "Half Jacket", value: "half_jacket"},
      {label: "Two Half Jacket", value: "two_half_jacket"},
      {label: "Three Half Jacket", value: "three_half_jacket"},
      {label: "Four Half Jacket", value: "four_half_jacket"},
      {label: "Five Half Jacket", value: "five_half_jacket"},
      {label: "Full Jacket", value: "full_jacket"},
      {label: "French Window", value: "french_window"},
    ],
     FrontPage: [
      {label: "No Front Page", value: null},
      {label: "Two Front Pages", value: "two_front_pages"},
      {label: "Three Front Pages", value: "three_front_pages"},
    ],
  });
  const [formErrorHelper, setFormErrorHelper] = useState({});

const changeDateValue = (date) => {
  setDateValue(date);

  setSelectedJacketType(null);
  setSelectedFrontPage(null);

  setUserSelectedJacket(false);
  setUserSelectedFrontPage(false);

  const formattedDate = date.toISOString().split("T")[0];

  setFormSubmittingData((prev) => ({
    ...prev,
    dateValue: formattedDate,
    jacketType: null,
    FrontPage: null,
  }));

  setFormErrorHelper((prev) => ({
    ...prev,
    dateValue: null,
  }));
};

useEffect(() => {
  if (!regionVal?.value || !dateValue) return;

  const formattedDate = dateValue.toISOString().split("T")[0];

  const storageKey = getPageConfigStorageKey(
    regionVal.value,
    formattedDate
  );

  let savedConfig = {};

  try {
    savedConfig = JSON.parse(
      localStorage.getItem(storageKey) || "{}"
    );
  } catch (error) {
    console.error("Error restoring page configuration:", error);
    console.log("RESTORING CONFIG");
console.log("REGION ID:", regionVal?.value);
console.log("DATE:", formattedDate);
console.log("STORAGE KEY:", storageKey);
console.log("SAVED CONFIG:", localStorage.getItem(storageKey));
  }

  const jacketType = savedConfig.jacketType || null;
  const frontPage = savedConfig.FrontPage || null;

  setSelectedJacketType(jacketType);
  setSelectedFrontPage(frontPage);

  setUserSelectedJacket(false);
  setUserSelectedFrontPage(false);

  setFormSubmittingData((prev) => ({
    ...prev,
    dateValue: formattedDate,
    jacketType,
    FrontPage: frontPage,
  }));
}, [regionVal?.value, dateValue]);

  const mapLabelValue = (arrayData) => {
    return arrayData?.map((el) => ({
      label: el?.name || el?.page_name,
      value: el?.id,
    }));
  };

  const handleSelectDropDownChange = (name, e) => {
  if (name === "jacketType" || name === "FrontPage") {
    const storageKey = getPageConfigStorageKey(
      regionVal?.value,
      dateValue
    );

    let savedConfig = {};

    try {
      savedConfig = JSON.parse(
        localStorage.getItem(storageKey) || "{}"
      );
    } catch (error) {
      console.error("Error reading page configuration:", error);
      console.log("SAVED CONFIG:", storageKey, savedConfig);
    }

    savedConfig[name] = e;

    localStorage.setItem(
      storageKey,
      JSON.stringify(savedConfig)
    );

    if (name === "jacketType") {
      setSelectedJacketType(e);
      setUserSelectedJacket(true);
    }

    if (name === "FrontPage") {
      setSelectedFrontPage(e);
      setUserSelectedFrontPage(true);
    }
  }

  setFormSubmittingData((prev) => ({
    ...prev,
    [name]: e,
  }));

  setFormErrorHelper((prev) => ({
    ...prev,
    [name]: null,
    paperNumber: null,
  }));
};
const submitHandler = (e) => {
  e.preventDefault();
  const publishDate = dateValue.toISOString().split('T')[0];


  dispatch(
    fetchParamsListData({
      // ...formSubmittingData,
      regionId: regionVal?.value,
      publish_date: publishDate,
    })
  );

  dispatch(
    fetchAdsListByPosting({
      ...formSubmittingData,
      regionId: regionVal?.value,
      // publish_date: publishDate,
    })
  );

  dispatch(
    fetchDataRequest({
      region_id: regionVal?.value,
      publish_date: publishDate,
    })
  );

  dispatch(
    getSummayDetails({
      region_id: regionVal?.value,
      publish_date: publishDate,
    })
  );
};

  useEffect(() => {
    const adTypeTransform = mapLabelValue(
      fetchMetaDataInitalDataParams?.[0]?.["ad_type"]
    );
    const pageNoTransform = mapLabelValue(
      fetchMetaDataInitalDataParams?.[0]?.["page_number"]
    );
    const positionTransform = mapLabelValue(
      fetchMetaDataInitalDataParams?.[0]?.["position"]
    );
    setDropDownValue((prev) => ({
      ...prev,
      adType: adTypeTransform,
      pageNumber: pageNoTransform,
      position: positionTransform,
    }));
  }, [fetchMetaDataInitalDataParams]);

  useEffect(() => {
    if (regionVal && dateValue) {
      const publishDate = dateValue.toISOString().split("T")[0];
      dispatch(
        fetchParamsListData({
          regionId: regionVal?.value,
          publish_date: publishDate,
        })
      );
    }
  }, [regionVal, dateValue]);

  useEffect(() => {
    setFormSubmittingData((prev) => ({
      ...prev,
      editionType: { label: "Single", value: "single" },
      paperNumber: { label: "One", value: "one" },
    }));
  }, []);

  useEffect(() => {
    //setting paper to one , if the user already selected two and again selecting edition one.
    if (formSubmittingData?.editionType?.value === "single") {
      if (formSubmittingData?.paperNumber?.value === "two") {
        setFormSubmittingData((prev) => ({
          ...prev,
          editionType: { label: "Single", value: "single" },
          paperNumber: { label: "One", value: "one" },
        }));
      }
    }
  }, [formSubmittingData?.editionType, formSubmittingData?.paperNumber]);

  return (
    <div>
      <form onSubmit={submitHandler}>
        <div className="fetchForm">
            <h6 style={{fontSize:"larger"}}>Filter Ads</h6>
            <Col className="wrapper">
              {/*<Row xl={3} lg={3} md={1} sm={1} xs={1}>*/}
              <Row xs={1}>
                {/* <Col>
                  <div className="selectDrop adTypeDrop">
                    <span className="label">Ad Type</span>
                    <Select
                      name="adType"
                      options={dropDownValue?.adType}
                      isSearchable={true}
                      placeholder={
                        <div>
                          <i className="fa fa-search"></i> Search Ad type...
                        </div>
                      }
                      onChange={(e) => handleSelectDropDownChange("adType", e)}
                      value={formSubmittingData?.adType}
                    />
                  </div>
                </Col> */}
                <Col md={12}>
                  <div className="selectDrop pageNoDrop">
                    <span className="label">Page No</span>
                    <Select
                      name="adType"
                      options={dropDownValue?.pageNumber}
                      isClearable
                      isSearchable={true}
                      placeholder={
                        <div>
                          <i className="fa fa-search"></i> Search page number...
                        </div>
                      }
                      onChange={(e) =>
                        handleSelectDropDownChange("pageNumber", e)
                      }
                      value={formSubmittingData?.pageNumber}
                    />
                    {formErrorHelper?.pageNumber && (
                      <span className="errorField">
                        {formErrorHelper?.pageNumber}
                      </span>
                    )}
                  </div>
                </Col>
                <Col md={12}>
                  <div className="selectDrop  positionDrop">
                    <span className="label">Position</span>
                    <Select
                      name="position"
                      options={dropDownValue?.position}
                      isClearable
                      isSearchable={true}
                      placeholder={
                        <div>
                          <i className="fa fa-search"></i> Search position...
                        </div>
                      }
                      onChange={(e) =>
                        handleSelectDropDownChange("position", e)
                      }
                      value={formSubmittingData?.position}
                    />
                  </div>
                </Col>
                <Col md={12}>
                  <div className="selectDrop datePickerDrop">
                    <span className="label">Date </span>
                    <DatePicker
                      selected={dateValue}
                      onChange={changeDateValue}
                      showIcon
                      id={"filterDate"}
                      dateFormat="dd/MM/yyyy"
                    />
                    {formErrorHelper?.dateValue && (
                      <span className="errorField">
                        {formErrorHelper?.dateValue}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>
              {/*<Row xl={3} lg={3} md={1} sm={1} xs={1}>*/}
              <Row xs={1}>
                  <Col md={12}>
                  <div className="selectDrop editionTypeDrop">
                    <span className="label">Edition Type</span>
                    <Select
                      name="editionType"
                      options={dropDownValue?.editionType}
                      isClearable
                      // placeholder={<div><i className="fa fa-search"></i> Search position...</div>}
                      onChange={(e) =>
                        handleSelectDropDownChange("editionType", e)
                      }
                      value={formSubmittingData?.editionType}
                      placeholder={"Edition type. i.e: Single, Twin"}
                    />
                  </div>
                </Col>
                  <Col md={12}>
                  <div className="selectDrop jacketTypeDrop">
                    <span className="label">Jacket Type</span>
                    <Select
                        name="jacketType"
                        options={dropDownValue?.jacketType}
                        onChange={(e) =>
                            handleSelectDropDownChange("jacketType", e)
                        }
                        value={selectedJacketType || formSubmittingData?.jacketType}
                        placeholder={"Select Jacket Type"}
                    />
                  </div>
                </Col>
                  <Col md={12}>
                  <div className="selectDrop FrontPageDrop">
                    <span className="label">Front Page</span>
                    <Select
                        name="FrontPage"
                        options={dropDownValue?.FrontPage}
                        onChange={(e) =>
                            handleSelectDropDownChange("FrontPage", e)
                        }
                        value={selectedFrontPage || formSubmittingData?.FrontPage}
                        placeholder={"Select Front Page"}
                    />
                  </div>
                </Col>
                 <Col md={12}>
                  <div className="selectDrop paperNumberDrop">
                    <span className="label">Paper Number</span>
                    <Select
                      name="paperNumber"
                      options={dropDownValue?.paperNumber}
                      isClearable
                      // placeholder={<div><i className="fa fa-search"></i> Search position...</div>}
                      onChange={(e) =>
                        handleSelectDropDownChange("paperNumber", e)
                      }
                      value={formSubmittingData?.paperNumber}
                      placeholder={"PaperNumber. i.e: One, Two"}
                      isDisabled={
                        formSubmittingData?.editionType?.value === "single" ||
                        !formSubmittingData?.editionType
                      }
                    />
                    {formErrorHelper?.paperNumber && (
                      <span className="errorField">
                        {formErrorHelper?.paperNumber}
                      </span>
                    )}
                  </div>
                </Col>
                 <Col md={12}>
                <div className="fetchSub"> 
                {fetcheadsbypositingLoading  && data ?(
                  <div>
                    <Loader />
                  </div>
                ) : (
                  <Button type="submit" >Fetch Ads</Button>
                )}
              </div></Col>
              </Row>
            </Col>
        </div>
      </form>
    </div>
  );
}
